import { SubscriptionStatus } from '../types/device';
export const hideTrends = (getPartNumberData: any) => {
    let error = false;

    const subscription = getPartNumberData ? getPartNumberData : {};

    // useEffect(() => {
    if (getPartNumberData && subscription.length !== 0) {
        if (subscription.subscriptionDetails.subscriptionStatus === SubscriptionStatus.Expired) {
            error = true;
        } else {
            error = false;
        }
    } else if (subscription.length === 0 || subscription.subscriptionDetails.expirationDate === null) {
        error = false;
    }
    // }, [getPartNumberData]);

    return error;
};
